import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconMixerStyle0 = gravityIconIndividualCss;

const GravityIconMixer = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '9e2d62a8d8ed8e4f69251d7883cfde5fb7d3c6fd', color: this.color, size: this.size }, h("svg", { key: 'b739a2ece132d27a8afe2ae71ae69d471cb346c0', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '0f76d24d28076452c2a5409e0ed818f4df435d76', d: "M17.513 5.192a1.425 1.425 0 0 0-2.104.2l-3.991 5.365a.378.378 0 0 0 0 .443l4.008 5.409c.496.67 1.47.773 2.104.2.557-.505.592-1.357.148-1.957l-2.878-3.87 2.86-3.834c.444-.6.4-1.452-.147-1.956Zm-13.026 0a1.425 1.425 0 0 1 2.105.2l4 5.373a.379.379 0 0 1 0 .444l-4.018 5.4c-.495.67-1.47.773-2.104.2-.556-.505-.591-1.357-.148-1.957l2.878-3.87-2.86-3.834c-.444-.6-.4-1.452.147-1.956Z", fill: "currentColor" }))));
    }
};
GravityIconMixer.style = GravityIconMixerStyle0;

export { GravityIconMixer as gravity_icon_mixer };

//# sourceMappingURL=gravity-icon-mixer.entry.js.map